export const updateAuthKey = "UPDATE_AUTH_KEY";
export const loginLoaderState = "LOGIN_LOADER_STATE";
export const registerLoaderState = "REGISTER_LOADER_STATE";
export const forgotPasswordLoaderState = "FORGOT_LOADER_STATE";
export const resetPasswordLoaderState = "RESET_PASS_LOADER_STATE";
export const updateLastWorkedWorkspace = "UPDATE_LAST_WORKED_WORKSPACE";
export const isGoogleSignIn = "isGoogleSignIn";
export const isAppleSignIn = "isAppleSignIn";
